import client from './client';

export const listAnnouncements = () => client.get('/announcements').then((r) => r.data);
export const activeAnnouncements = () => client.get('/announcements/active').then((r) => r.data);
export const createAnnouncement = (payload) => client.post('/announcements', payload).then((r) => r.data);
export const removeAnnouncement = (id) => client.delete(`/announcements/${id}`).then((r) => r.data);
export const ackAnnouncement = (id) => client.post(`/announcements/${id}/ack`).then((r) => r.data);
export const announcementAcks = (id) => client.get(`/announcements/${id}/acks`).then((r) => r.data);

// Thông báo gửi KHÁCH HÀNG (vào hộp tin nhắn KH, kênh CSKH) — GĐ/CSKH.
export const custAnnOptions = () => client.get('/customer-announcements/options').then((r) => r.data);
export const custAnnList = () => client.get('/customer-announcements').then((r) => r.data);
export const custAnnPreview = (scope) => client.post('/customer-announcements/preview', { scope }).then((r) => r.data);
export const custAnnRecipients = (scope) => client.post('/customer-announcements/recipients', { scope }).then((r) => r.data);
export const custAnnCreate = (payload) => client.post('/customer-announcements', payload).then((r) => r.data);
